import { render, staticRenderFns } from "./GListPage.vue?vue&type=template&id=26639a97&scoped=true"
import script from "./GListPage.vue?vue&type=script&lang=js"
export * from "./GListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26639a97",
  null
  
)

export default component.exports